import type { IApiLeaderBoardResponse, IApiResponse, IApiUserImagesResponse, IUserStatsResponse } from '@/services';

export * from './types';

import type { AxiosInstance, AxiosResponse } from 'axios';
import type { IUserAvatarData, IUserScoreData, IUserStatsData } from '@/entities/leaderboard';
import { mapUserAvatar, mapUserScore, mapUserStats } from '@/mappers';

export class ApiLeaderboardEndpoint {
  axios: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance;
  }

  async fetchUserStats(): Promise<IUserStatsData> {
    const response: AxiosResponse<IApiResponse<IUserStatsResponse>> = await this.axios
      .get(`leaderboard/widget`)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return mapUserStats(response.data.data);
    }

    return Promise.reject();
  }

  async fetchUserScores(page: number, pageSize: number): Promise<{ data: IUserScoreData[]; pageCount: number }> {
    const response: AxiosResponse<IApiResponse<IApiLeaderBoardResponse>> = await this.axios
      .get(`leaderboard`, {
        params: {
          page,
          count: pageSize
        }
      })
      .catch(() => Promise.reject());

    if (response?.data.data?.userScores) {
      return {
        data: response.data.data.userScores.map((l) => mapUserScore(l)),
        pageCount: response.data.data.pageCount
      };
    }

    return Promise.reject();
  }

  async fetchUserAvatars(userIds: string[]): Promise<IUserAvatarData[]> {
    const response: AxiosResponse<IApiResponse<IApiUserImagesResponse[]>> = await this.axios
      .get(`users?${userIds.map((id) => `ids=${id}`).join('&')}`)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.map((l) => mapUserAvatar(l));
    }

    return Promise.reject();
  }
}
